import { deletePropertyHandler } from '~/api/gen'
import { createPropertyHandler } from './overrides/createPropertyHandler'
import { getPropertyByIdHandler } from './overrides/getPropertyByIdHandler'
import { searchPropertiesHandler } from './overrides/searchPropertiesHandler'
import { updatePropertyHandler } from './overrides/updatePropertyHandler'

export const handlers = [
  searchPropertiesHandler(),
  createPropertyHandler(),
  getPropertyByIdHandler(),
  deletePropertyHandler({ success: true }),
  updatePropertyHandler(),
]
